import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { Customer } from '../models/customer.model';
import { GLOBAL } from './global';
import { VariableService } from '../services/sharedVariables';

@Injectable()
export class CustomerService{
   public url: string;
   public user_id: number;
   constructor(
     public _http: Http,
     public variableService:VariableService
   )
   {
     this.url = GLOBAL.url;
     this.user_id = parseInt(this.variableService.getCookie('user_id'));

   }

   getCustomers()
   {
     return this._http.get(this.url+'customers/'+this.user_id).map(res => res.json());
   }

   getCustomer()
   {
     return "getCustomer from service";
   }

   addCustomer(customer: Customer)
   {
     let json = JSON.stringify(customer);
     let params = 'json='+json;     
     let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
     console.log(headers,'adding');
     return this._http.post(this.url + 'add-customer/' + this.user_id,params,{headers:headers})
                      .map(res => res.json());
   }

   updateCustomer(id:number,pCustomer: Customer)
   {
     let json = JSON.stringify(pCustomer);
     let params = "json="+json;
     let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
     console.log(headers,'update');
     return this._http.post(this.url+'edit-customer/'+id+'/'+this.user_id,params,{headers: headers})
                       .map(res => res.json());
   }

   deleteCustomer(id:number)
   {
     return this._http.get(this.url+'delete-customer/'+id+'/'+this.user_id)
                     .map(res => res.json());
   }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/services/customer.service.ts